import * as types from './types'

export const clearFilter = (filter) => ({
  type: types.CLEAR_FILTER,
  payload: { filter },
})

export const clearFilters = () => ({
  type: types.CLEAR_FILTERS,
})

export const setOrder = (order) => ({
  type: types.SET_ORDER,
  payload: { order },
})

export const gotoPage = (page) => ({
  type: types.GET_RESULTS_PAGE,
  payload: { page },
})

export const toggleWishlist = (property) => ({
  type: types.TOGGLE_WISHLIST,
  payload: { property },
})

export const lookupEvent = (q) => ({
  type: types.LOOKUP_EVENT,
  payload: { q },
})

export const setActiveProperty = (property) => ({
  type: types.SET_ACTIVE_PROPERTY,
  payload: { property },
})

export const resetAllFilters = () => ({
  type: types.APPLY_FILTER,
  payload: {
    types: [],
    minBedrooms: null,
    maxBedrooms: null,
    minBeds: null,
    maxBeds: null,
    minBudget: null,
    maxBudget: null,
    amenities: []
  },
})

export const filterType = () => ({
  type: types.FILTER,
  payload: { type: 'type' },
})

export const filterBedrooms = () => ({
  type: types.FILTER,
  payload: { type: 'bedrooms' },
})

export const filterBudget = () => ({
  type: types.FILTER,
  payload: { type: 'budget' },
})

export const showAllFilters = () => ({
  type: types.FILTER,
  payload: { type: 'all' },
})

export const applyFilter = (data) => ({
  type: types.APPLY_FILTER,
  payload: data,
})



// WEBPACK FOOTER //
// ./src/redux/modules/search/actions.js